<template>
    <spinner v-if="loading"></spinner>
    <div v-else>
        <div class="w-full" v-if="section === 'futures' && quotes">
            <div class="text-sm mb-1 font-bold">Select Contract:</div>
            <div class="selector-wrapper">
                <contract-selector
                    v-model="symbol"
                    :initial="quotes.symbol"
                    :all-contracts="quotes.futures"
                />
            </div>
        </div>

        <div class="w-full" v-if="(section === 'forex' || section === 'crypto') && quotes">
            <div class="text-sm mb-1 font-bold">Select Crossrate:</div>
            <div class="selector-wrapper">
                <forex-selector
                    v-model="symbol"
                    :symbols="quotes.forex || quotes.crypto"
                />
            </div>
        </div>

        <div class="w-full" v-if="section === 'future-spreads' && quotes">
            <div class="text-sm mb-1 font-bold">Select Futures Spread:</div>
            <div class="selector-wrapper">
                <spread-selector
                    v-model="symbol"
                    :spreads="quotes.spreads"
                    :all-contracts="quotes.futures"
                />
            </div>
        </div>

        <div class="w-full" v-if="section === 'future-options' && quotes">
            <div class="text-sm mb-1 font-bold">Select Strike:</div>
            <div class="selector-wrapper">
                <option-selector-2
                    v-model="symbol"
                    :groups="quotes.options"
                />
            </div>
        </div>

        <div class="w-full" v-if="section === 'stock-etf'">
            <div class="text-sm mb-1 font-bold">Enter a symbol:</div>
            <div class="selector-wrapper">
                <stock-search-selector v-model="symbol" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';

const props = defineProps({
    section: {
        type: String,
        required: true
    },
    modelValue: {
        type: [String, Object],
        default: null, // You can set a default value if necessary
    },
});

const emit = defineEmits(['update:modelValue']);

const quotes = ref(null);
const symbol = ref(null);
const loading = ref(true);

watch(symbol, (newValue) => {
    emit('update:modelValue', newValue);
});

const getQuotes = async () => {
    const route = window.route('api.quotes.symbol-select');
    const params = { section: props.section };
    try {
        const response = await axios.post(route, params);
        loading.value = false;
        quotes.value = response.data;
    } catch (error) {
        console.error('Could not retrieve quotes');
    }
};

// Lifecycle hook
onMounted(() => {
    getQuotes();
});
</script>
